import {Injectable} from '@angular/core';
import {NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class ReportDatepickerFormatService {
  dateInputFormat = 'MM/DD/YYYY';
}

@Injectable()
export class ReportDatepickerParserFormatter extends NgbDateParserFormatter {
  constructor(private readonly formatService: ReportDatepickerFormatService) {
    super();

  }


  parse(value: string | null | undefined): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    const cleaned = value.trim();
    if (!cleaned) {
      return null;
    }

    const separator = cleaned.includes('-') ? '-' : cleaned.includes('/') ? '/' : null;
    if (separator) {
      const parts = cleaned.split(separator).map(part => part.trim());
      if (parts.length === 3) {
        const format = this.formatService.dateInputFormat.toUpperCase();
        let year: number;
        let month: number;
        let day: number;

        if (format.startsWith('YYYY') || parts[0].length === 4) {
          year = Number(parts[0]);
          month = Number(parts[1]);
          day = Number(parts[2]);
        } else if (Number(parts[0]) > 12 && Number(parts[1]) <= 12) {
          day = Number(parts[0]);
          month = Number(parts[1]);
          year = Number(parts[2]);
        } else {
          month = Number(parts[0]);
          day = Number(parts[1]);
          year = Number(parts[2]);
        }

        if (year && month && day) {
          return {year, month, day};
        }
      }
    }

    const parsed = new Date(cleaned);
    if (!Number.isNaN(parsed.getTime())) {
      return {
        year: parsed.getFullYear(),
        month: parsed.getMonth() + 1,
        day: parsed.getDate(),
      };
    }

    return null;
  }

  format(date: NgbDateStruct | null): string {
    if (!date) {
      return '';
    }

    const year = date.year.toString().padStart(4, '0');
    const month = date.month.toString().padStart(2, '0');
    const day = date.day.toString().padStart(2, '0');
    return `${month}/${day}/${year}`;
  }
}

@Injectable()
export class ReportDatepickerAdapter extends NgbDateAdapter<string | Date | null> {
  constructor(private readonly formatter: NgbDateParserFormatter) {
    super();
  }

  fromModel(value: string | Date | NgbDateStruct | null): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'object' && 'year' in value && 'month' in value && 'day' in value) {
      const struct = value as NgbDateStruct;
      if (struct.year && struct.month && struct.day) {
        return struct;
      }
    }

    if (value instanceof Date) {
      return {
        year: value.getFullYear(),
        month: value.getMonth() + 1,
        day: value.getDate(),
      };
    }

    if (typeof value === 'string') {
      return this.formatter.parse(value);
    }

    return null;
  }

  toModel(date: NgbDateStruct | null): string | Date | null {
    if (!date) {
      return null;
    }

    return this.formatter.format(date);
  }
}
